import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'postgresql',
  name: 'PostgreSQL',
  category: 'database',
  description: 'Execute SQL queries and manage tables on PostgreSQL databases',
  icon: 'siPostgresql',
  iconType: 'simple-icon',
  color: 'indigo',
  version: '1.0.0',
  credentials: [
    {
      name: 'postgresql',
      required: true,
      displayName: 'PostgreSQL',
    },
  ],
  tags: ['postgresql', 'postgres', 'database', 'sql', 'db'],
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],

  // Tool-capable configuration for AI Agent
  toolCapable: {
    enabled: true,
    name: 'postgresql_database',
    description: 'Execute SQL queries and operations on PostgreSQL databases. Supports SELECT, INSERT, UPDATE, DELETE, bulk operations, and table management (create, drop, truncate, schema).',
    allowManualDescription: true,
    parameters: {
      operation: {
        toolParamName: 'operation',
        description: 'The database operation to perform: executeQuery, insert, update, delete, createTable, bulkInsert, dropTable, truncateTable, tableExists, or getTableSchema',
        required: true,
        type: 'string',
      },
      query: {
        toolParamName: 'query',
        description: 'The SQL query to execute (for executeQuery operation)',
        required: false,
        type: 'string',
      },
      table: {
        toolParamName: 'table',
        description: 'The table name for table operations',
        required: false,
        type: 'string',
      },
      sourceArray: {
        toolParamName: 'sourceArray',
        description: 'Source array data for createTable or bulkInsert operations',
        required: false,
        type: 'array',
      },
      parameters: {
        toolParamName: 'parameters',
        description: 'Query parameters as key-value pairs (use $1, $2... or @paramName syntax)',
        required: false,
        type: 'object',
      },
    },
    outputMapping: {
      rows: 'The query result rows or affected data',
      rowCount: 'Number of rows affected or returned',
      success: 'Whether the operation completed successfully',
      exists: 'Whether the table exists (for tableExists operation)',
      schema: 'Table schema information (for getTableSchema operation)',
    },
  },
};

export default definition;
